import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "id", "value"]
const _hoisted_2 = ["for"]


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckBoxTag',
  props: {
		icon: {
			type: String,
			default: "/media/icons/user-icon.svg",
		},
		name: {
			type: String,
			default: "",
		},
		value: {
			type: String,
			default: "",
		},
		label: {
			type: String,
			default: "Value of radio",
		},
		css: {
			type: String,
			default: "",
		},
	},
  emits: ["model"],
  setup(__props) {

	const props = __props;
	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			__props.css,
			{
				'flex flex-row items-center px-4 py-2 m-2 space-x-2 bg-transparent border rounded-lg border-secondary justify-start': true,
			},
		])
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      class: "bg-transparent outline-none focus:outline-none",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('model', $event.target?.checked ? 1 : 0))),
      name: __props.name,
      id: __props.label,
      value: __props.value == '' ? __props.label : __props.value
    }, null, 40, _hoisted_1),
    _createElementVNode("label", { for: __props.label }, _toDisplayString(__props.label), 9, _hoisted_2)
  ], 2))
}
}

})